import { configureStore } from '@reduxjs/toolkit';
import { baseApi } from '../api';
import { userSlice } from './user';
import { accountSlice } from './account';

const store = configureStore({
  reducer: {
    [baseApi.reducerPath]: baseApi.reducer,

    user: userSlice.reducer,
    account: accountSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }).concat(baseApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;

export default store;
